import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { CalendarModule } from '@nedoShared/modules/calendar';
const CalendarPage = () => {
    return (_jsx("div", Object.assign({ className: "content" }, { children: _jsx(CalendarModule, {}) })));
};
export default observer(CalendarPage);
